import { createContext } from 'react';

export const XYChartLoadingContext = createContext<boolean | undefined>(
  undefined,
);

XYChartLoadingContext['displayName'] = 'XYChartLoadingContext';
